import { collection, setDoc, doc, getDoc, getDocs } from "firebase/firestore";
import { firestore } from "./firebase";

export async function fetchCustomAnswers() {
  const response = await fetch("https://go.screver.com/api/v1/tableau/ad2c2677-e7ba-4e42-8c79-d06ace21539a");
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  const json = await response.json();

  return json.data
    .map(({ _id, answer }) => {
      if (_id == "684580bf945c5723b32e4c2c" || _id == "68457c3b945c5723b32e48d1") {
        return null; /* Filter is crucial for those 2 ID because those answer IDs cannot be deleted from JSON even if answers are deleted from screver, and they are repeatedly showing in firebase. (probably some bug) so this if statment resolve the issue  */
      }
      let customAnswer = null;

      for (const key in answer) {
        if (answer[key] && typeof answer[key] === "object" && "customAnswer" in answer[key]) {
          customAnswer = answer[key].customAnswer;
          break;
        }
      }

      if (customAnswer) {
        return { id: _id, answer: customAnswer };
      }
      return null;
    })
    .filter((item) => item !== null);
}

export async function saveCustomAnswersToFirestore(customAnswers) {
  const collectionRef = collection(firestore, "customAnswers");

  for (const { id, answer } of customAnswers) {
    try {
      const docRef = doc(collectionRef, id);
      const existingDoc = await getDoc(docRef);

      if (existingDoc.exists()) {
        const existingData = existingDoc.data();

        if (existingData.answer === answer) {
          continue;
        }
      }

      await setDoc(docRef, { id, answer, approved: false }, { merge: true });
      console.log("Custom answer saved or updated:", answer);
    } catch (error) {
      console.error("Error saving/updating custom answer:", error);
    }
  }
}

export async function fetchAndSave() {
  try {
    const customAnswers = await fetchCustomAnswers();
    await saveCustomAnswersToFirestore(customAnswers);
  } catch (error) {
    console.error("error:", error);
  }
}

export async function fetchApprovedCustomAnswersFromFirestore() {
  const collectionRef = collection(firestore, "customAnswers");
  const snapshot = await getDocs(collectionRef);
  const answers = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })).filter((item) => item.approved === true);
  return answers;
}
